export default __webpack_public_path__ + "static/media/play-store.2b153651.png";